import { addZeroStartStr } from './ui';
import { l10nType } from "@type/index";

export const setYMDDateFormat = (value: string | number) => {
    const d = new Date(value);
    const yearStr = `${d?.getFullYear()}`;
    const monthStr = `${d?.getMonth() + 1}`;
    const dateStr = `${d?.getDate()}`;

    return `${yearStr}.${monthStr?.padStart(2, '0')}.${dateStr?.padStart(2, '0')}`;
}

export const setDateFormat = (dateStr: string, l10n: l10nType) => {
    const now = window.userData?.now ? new Date(window.userData?.now)?.getTime() : new Date().getTime();
    const createTime = new Date(dateStr)?.getTime() || 0;
    const howTime = (now - createTime) / 1000;
    const hasPerS = (str: string) => str?.includes('%s');
    const timeMap = [
        {
            getIsOk: (val: number) => val < 60,
            getTransform: () => {
                return l10n?.template?.fewSecondsAgo;
            }
        },
        {
            getIsOk: (val: number) => val >= 60 && val < 3600,
            getTransform: (val: number) => {
                const time = Math.floor(val / 60);
                const text = l10n?.template?.minutesAgo;
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', `${time}`) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val: number) => val >= 3600 && val < 86400,
            getTransform: (val: number) => {
                const time = Math.floor(val / (60 * 60));
                const text = l10n?.template?.hoursAgo;
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', `${time}`) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val: number) => val >= 86400 && val < 604800,
            getTransform: (val: number) => {
                const time = Math.floor(val / (60 * 60 * 24));
                const text = l10n?.template?.daysAgo;
                const isPerS = hasPerS(text);
                return isPerS ? text?.replaceAll('%s', `${time}`) : `${time}${text}`;
            }
        },
        {
            getIsOk: (val: number) => val >= 604800,
            getTransform: () => {
                return setYMDDateFormat(createTime);
            }
        }
    ];

    let timeElm: string = '';
    timeMap?.some(v => {
        if(!v?.getIsOk(howTime)) {
            return false;
        }

        timeElm = v?.getTransform(howTime);
        return true;
    });

    return timeElm;
};

export const setTimeFormat = (time: number | string) => {
    const timeNum = typeof time === 'number' ? time : parseInt(time, 10);
    const hours   = Math.floor(timeNum / 3600);
    const minutes = Math.floor((timeNum - (hours * 3600)) / 60);
    const seconds = timeNum - (hours * 3600) - (minutes * 60);

    return `${hours > 0 ? `${addZeroStartStr(hours, 2)}:` : ''}${minutes >= 0 ? `${addZeroStartStr(minutes, 2)}:` : ''}${seconds >= 0 ? `${addZeroStartStr(seconds, 2)}` : ''}`
  }